import Cookies from 'js-cookie';
import { jwtDecode } from 'jwt-decode';

import { TOKEN_COOKIE_NAME } from '@/_lib/constants';

interface JwtPayload {
  exp: number;
  [key: string]: any;
}

export function getToken(tokenName: string = TOKEN_COOKIE_NAME): string | null {
  return Cookies.get(tokenName) ?? null;
}

export function isTokenExpired(token: string): boolean {
  try {
    const decoded = jwtDecode<JwtPayload>(token);
    if (!decoded.exp) return true;

    const now = Date.now() / 1000;
    return decoded.exp < now;
  } catch (err) {
    return true;
  }
}
